import { render, staticRenderFns } from "./TheWalletSideMenu.vue?vue&type=template&id=387e17f6&scoped=true"
import script from "./TheWalletSideMenu.vue?vue&type=script&lang=js"
export * from "./TheWalletSideMenu.vue?vue&type=script&lang=js"
import style0 from "./TheWalletSideMenu.vue?vue&type=style&index=0&id=387e17f6&prod&lang=scss&scoped=true"
import style1 from "./TheWalletSideMenu.vue?vue&type=style&index=1&id=387e17f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e17f6",
  null
  
)

export default component.exports